export const FEATURE_PRICE_TYPE_PRICE = 'price';
export const FEATURE_PRICE_TYPE_PRICE_PER_PAGE = 'pricePerPage';
export const FEATURE_PRICE_TYPE_PRICE_PER_SOURCE = 'pricePerSource';